/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_Sc6Inputs */

const en_fc_tut_sc6 = /** @type {(inputs: Fc_Tut_Sc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamic trim back / stop / forward`)
};

/**
* | output |
* | --- |
* | "Dynamic trim back / stop / forward" |
*
* @param {Fc_Tut_Sc6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_sc6 = /** @type {((inputs?: Fc_Tut_Sc6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_Sc6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_sc6(inputs)
});
export { fc_tut_sc6 as "fc.tut.sc6" }